import React from "react";
import PropTypes from "prop-types";

const SuccessModal = ({ show, onClose, title = "success", message = "Document sent successfully !" }) => {
    if (!show) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>{title}</h3>
                <p>{message}</p>
                <button className="btn-ok" onClick={onClose}>ok</button>
            </div>
        </div>
    );
};

SuccessModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    message: PropTypes.string,
}
export default SuccessModal;